import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UserDetailsManager } from '@shared-managers/user-details.manager';
import { IUserDetails } from '@shared-models/user.model';
import { isEmpty } from 'lodash';

@Component({
	selector: 'form-communication-component',
	templateUrl: 'form-communication.component.html',
	styleUrls: ['./form-communication.component.scss'],
})
export class FormCommunicationComponent implements OnChanges {
	@Input() public communication: Array<{ control: FormControl; label: string }>;
	@Input() public replyTo: FormControl;
	@Input() public telephone: FormControl;

	constructor(private readonly userDetailsManager: UserDetailsManager) {}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.replyTo.isFirstChange() && changes.replyTo.currentValue) {
			this.userDetailsManager.getUserDetails().subscribe((result: IUserDetails) => {
				if (isEmpty(changes.replyTo.currentValue.value)) {
					this.replyTo.setValue(result.replyTo);
				}
			});
		}
		if (this.telephone) {
			if (changes.telephone.isFirstChange() && changes.telephone.currentValue) {
				this.userDetailsManager.getUserDetails().subscribe((result: IUserDetails) => {
					if (isEmpty(changes.telephone.currentValue.value)) {
						this.telephone.setValue(result.telephone);
					}
				});
			}
		}
	}
}
